const PAGES = {
  get: function() {
    var pages = [];
    pages.push({
      name: 'about',
      label: 'ABOUT',
      path: '/about',
      color: '#fa7268'
    });
    pages.push({
      name: 'work',
      label: 'WORK',
      path: '/work',
      color: '#58b0ae'
    });
    pages.push({
      name: 'play',
      label: 'PLAY',
      path: '/play',
      color: '#efbf62'
    });
    pages.push({
      name: 'contact',
      label: 'CONTACT',
      path: '/contact',
      color: '#94b55d'
    });
    return pages;
  }
};

export default PAGES.get();
